import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { PositionCountForEntityUseCaseInterface } from 'domain/usecases';

export class RemotePositionCountForEntity
  implements PositionCountForEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<PositionCountForEntityUseCaseInterface.Result>,
  ) {}

  async execute(
    params: PositionCountForEntityUseCaseInterface.Params,
  ): Promise<PositionCountForEntityUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + params.id + '/overview/roles-count',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
